import { defineStore } from 'pinia';

export const useRouteHistoryStore = defineStore('route-history', {
  state: () => ({
    previousRoute: '' as string,
  }),

  actions: {
    setPreviousRoute(route: string) {
      this.previousRoute = route;
    },
  },
});
